import { Box, Skeleton, styled, Typography } from "@mui/material";
import React, { useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import AddIcon from "@mui/icons-material/Add";
import Logo from "../../../assets/logoStudioPBADS.png";

const PREFIX = "ImageAndTitle";

const classes = {
  myExparienceImage: `${PREFIX}-myExparienceImage`,
  skeletonImage: `${PREFIX}-skeletonImage`,
  itemTitle: `${PREFIX}-itemTitle`,
  buttonPosition: `${PREFIX}-buttonPosition`,
  iconSize: `${PREFIX}-iconSize`,
};

const StyledDiv = styled("div")(({ theme }) => ({
  [`& .${classes.myExparienceImage}`]: {
    height: "100px",
    width: "105px",
    [theme.breakpoints.between("xs", "md")]: {
      height: "70px",
      width: "75px",
      // transform: 'translateX(10px)',
    },
    borderRadius: "10%",
  },

  [`& .${classes.skeletonImage}`]: {
    height: "100px",
    width: "105px",
    [theme.breakpoints.between("xs", "md")]: {
      height: "70px",
      width: "75px",
      // transform: 'translateX(10px)',
    },
    borderRadius: "10%",
  },

  [`& .${classes.itemTitle}`]: {
    color: "white",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    width: "105px",
    maxWidth: "100%",
    [theme.breakpoints.between("xs", "md")]: {
      fontSize: "12px",
      left: "0",
      width: "91px",
    },
    fontSize: "20px",
    textAlign: "center",
  },

  [`& .${classes.buttonPosition}`]: {
    position: "absolute",
    zIndex: "999",
    top: "-8px",
    right: "-12px",
    border: "none",
    cursor: "pointer",
    backgroundColor: "rgb(33 33 33 / 80%)",
    borderRadius: "50%",
    width: "32px",
    height: "30px",
    [theme.breakpoints.between("xs", "md")]: {
      width: "25px",
      height: "23px",
      top: "-8px",
      right: "4px",
    },
  },

  [`& .${classes.iconSize}`]: {
    width: "20px",
    height: "25px",
    transform: "translateY(2px)",
    [theme.breakpoints.between("xs", "md")]: {
      transform: "translate(-8px, -1px)",
    },
  },
}));

const ImageAndTitle = ({
  image,
  title,
  onRemove = undefined,
  onAdd = undefined,
}) => {
  const [loading, setLoading] = useState(true);

  return (
    <StyledDiv>
      <Box
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {loading && (
          <Skeleton variant="rectangular" className={classes.skeletonImage} />
        )}
        {!loading && onRemove && (
          <button className={classes.buttonPosition} onClick={onRemove}>
            <ClearIcon color="primary" className={classes.iconSize} />
          </button>
        )}
        {!loading && onAdd && (
          <button className={classes.buttonPosition} onClick={onAdd}>
            <AddIcon color="primary" className={classes.iconSize} />
          </button>
        )}
        <img
          src={image || Logo}
          alt={title}
          className={classes.myExparienceImage}
          style={{ display: loading ? "none" : "inherit" }}
          onLoad={() => setLoading(false)}
        />

        <Typography variant="body1" className={classes.itemTitle}>
          {title}
        </Typography>
      </Box>
    </StyledDiv>
  );
};

export default ImageAndTitle;
